import { render, staticRenderFns } from "./PosturasListByLote.vue?vue&type=template&id=7fd36b39"
import script from "./PosturasListByLote.vue?vue&type=script&lang=js"
export * from "./PosturasListByLote.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports